export function getFontSizeValue(value) {
  let fontSize = value;
  fontSize = value.replace('px', '');
  return +fontSize;
}
